import { Layers } from "lucide-react";

// USA parcels whose CN22 label lists only 2 of N products.
export const TrimmedProductsBadge = ({ parcels, testId }) => {
  if (!parcels?.length) return null;
  const tip = parcels.map((p) => `${p.name || p.tracking}: 2 of ${p.total} products → ${p.label_text}`).join("\n");
  return (
    <span title={tip} data-testid={testId}
      className="inline-flex items-center gap-1 ml-1.5 px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 text-[10px] font-semibold cursor-help whitespace-nowrap">
      <Layers className="w-3 h-3" />
      {parcels.length} × 2 of N
    </span>
  );
};
